{
  "name": "pokemon-auto-chess",
  "version": "6.10.0",
  "assetsVersion": "6.10.0.2026-05-30.0",
  "translationsVersion": "6.10.0-2026-05-30.0",
  "description": "Pokemon Auto Chess Game. Made by fans for fans. Open source, non profit. All rights to the Pokemon Company.",
  "keywords": [],
  "license": "BSD-3-Clause",
  "engines": {
    "node": ">=20.16.0",
    "npm": ">=10.8.1"
  },
  "homepage": "https://github.com/keldaanCommunity/pokemonAutoChess#readme",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/keldaanCommunity/pokemonAutoChess.git"
  },
  "bugs": {
    "url": "https://github.com/keldaanCommunity/pokemonAutoChess/issues"
  },
  "author": "keldaan-ag",
  "contributors": [
    "ogus",
    "sylvainpolletvillard"
  ],
  "main": "public/dist/server/app/index.js",
  "scripts": {
    "dev-client": "node esbuild.js --dev",
    "dev-server": "ts-node-dev --watch \"src/**/*\" --respawn --transpile-only ./app/index.ts",
    "dev": "npm-run-all --parallel dev-*",
    "lint": "npx @biomejs/biome lint app/",
    "format": "npx @biomejs/biome format app/ --write",
    "check": "npx @biomejs/biome check app/ --write",
    "check:unsafe": "npx @biomejs/biome check app/ --write --unsafe",
    "build-client": "node esbuild.js --build",
    "build-server": "tsc",
    "download-music": "degit --force https://github.com/keldaanCommunity/pokemonAutoChessMusic ./app/public/src/assets/musics",
    "build": "npm run build-client && npm run build-server",
    "start": "node ./app/public/dist/server/app/index.js",
    "postinstall": "npm run download-music && cd edit/assetpack && npm install",
    "assetpack": "cd edit/assetpack && npm run assetpack",
    "csv-export": "cd gen && ts-node csv-export.ts",
    "check-labels": "cd gen && ts-node check-labels.ts",
    "add-pokemon": "cd edit && ts-node add-pokemon.ts",
    "colyseus-post-deploy": "npx colyseus-post-deploy",
    "deploy-live": "pm2 deploy production update",
    "setup-live": "pm2 deploy production setup",
    "check-circular-refs": "npx dpdm ./app -T --no-warning --no-tree",
    "knip": "knip --max-show-issues 5"
  },
  "dependencies": {
    "@colyseus/command": "^0.3.1",
    "@colyseus/monitor": "^0.17.7",
    "@colyseus/redis-driver": "^0.17.6",
    "@colyseus/redis-presence": "^0.17.6",
    "@colyseus/schema": "^4.0.25",
    "@colyseus/sdk": "^0.17.42",
    "@colyseus/tools": "^0.17.18",
    "@colyseus/ws-transport": "^0.17.9",
    "@reduxjs/toolkit": "^2.3.0",
    "colyseus": "^0.17.10",
    "cors": "^2.8.5",
    "cron": "^4.3.1",
    "d3": "^7.8.5",
    "dayjs": "^1.11.13",
    "discord.js": "^14.26.4",
    "dotenv": "^17.4.2",
    "express": "^5.2.1",
    "express-basic-auth": "^1.2.0",
    "fast-xml-parser": "^5.7.3",
    "firebase": "^10.0.0",
    "firebase-admin": "^13.9.0",
    "firebaseui": "^6.1.0",
    "fs-extra": "^11.3.5",
    "graceful-fs": "^4.2.10",
    "helmet": "^8.0.0",
    "html2canvas": "^1.4.1",
    "i18next": "^26.0.10",
    "i18next-browser-languagedetector": "^8.0.0",
    "i18next-http-backend": "^3.0.6",
    "immer": "^11.1.8",
    "jimp": "^1.6.0",
    "loglevel": "^1.8.1",
    "markdown-to-config": "^0.4.0",
    "marked": "^18.0.3",
    "matter-js": "^0.20.0",
    "mongoose": "^9.6.2",
    "phaser": "^4.1.0",
    "phaser4-rex-plugins": "^4.0.6",
    "pm2-prom-module-client": "^1.0.3",
    "prom-client": "^15.1.1",
    "react": "^19.2.6",
    "react-circular-progressbar": "^2.1.0",
    "react-dom": "^19.2.6",
    "react-i18next": "^17.0.7",
    "react-pro-sidebar": "^1.1.0",
    "react-redux": "^9.1.2",
    "react-router": "^7.15.0",
    "react-tabs": "^6.0.2",
    "react-toastify": "^11.1.0",
    "react-tooltip": "^6.0.2",
    "react-virtualized-auto-sizer": "^2.0.3",
    "react-window": "^2.2.7",
    "recharts": "^3.6.0"
  },
  "devDependencies": {
    "@biomejs/biome": "^2.4.15",
    "@types/cors": "^2.8.17",
    "@types/d3": "^7.4.3",
    "@types/fs-extra": "^11.0.4",
    "@types/matter-js": "^0.20.0",
    "@types/node": "^24.12.0",
    "@types/react": "^19.0.0",
    "@types/react-dom": "^19.0.0",
    "csv-writer": "^1.6.0",
    "degit": "^2.8.4",
    "esbuild": "^0.28.0",
    "knip": "^6.12.2",
    "npm-run-all2": "^8.0.0",
    "pm2": "^7.0.1",
    "ts-node-dev": "^2.0.0",
    "typescript": "^5.9.3"
  }
}
